import { AudioManager } from "../../../AudioManager";
import { GameConstants } from "../../../GameConstants";
import { GameVars } from "../../../GameVars";
import { Button } from "../../../utils/Button";
import { SplashScene } from "../SplashScene";
import { CategoriesContainer } from "./CategoriesContainer";

export class CategoryContainer extends Phaser.GameObjects.Container {

    public boundingBox: Phaser.GameObjects.Rectangle;

    private progressionBar: Phaser.GameObjects.Image;
    private patch: Phaser.GameObjects.Image;
    private index: number;
    private marker: Phaser.GameObjects.Image;
    private locked: boolean;

    constructor(scene: Phaser.Scene, category: string, index: number) {
        
        super(scene);

        this.type = category;
        this.index = index;

        // ver cuantos niveles de esta categoria han sido jugados
        const n = GameVars.gameData.categoriesData[category].n;
        const numPlayed = GameVars.gameData.categoriesData[category].levelsData.length;
        let numUnlocked = 0;

        for (let i = 0; i < GameVars.gameData.categoriesData[category].levelsData.length; i++) {

            if (GameVars.gameData.categoriesData[category].levelsData[i].time !== null) {
                numUnlocked++;
            }
        }

        let progressionBarScale = 0;

        if (numPlayed > 0) { 

            this.locked = false;

            const backfroundCapsuleBtn = new Button(this.scene, 0, 0, "texture_atlas_1", "btn_category", "btn_category_hover");
            backfroundCapsuleBtn.onDown(this.onCategoryUp, this);
            this.add(backfroundCapsuleBtn);

            progressionBarScale = numUnlocked / n;

        } else {

            this.locked = true;

            const patchImgName = CategoriesContainer.CATEGORIES_DATA[this.index - 1].patch.name;
            const p = CategoriesContainer.CATEGORIES_DATA[index - 1].patch.p;

            this.patch = new Phaser.GameObjects.Image(scene, p.x, p.y, "texture_atlas_4", patchImgName);
            this.patch.alpha = .5;
            this.add(this.patch);

            const backgroundCapsuleLocked = new Phaser.GameObjects.Image(scene, 0, 0, "texture_atlas_1", "btn_category_locked");
            this.add(backgroundCapsuleLocked);

            const lock = new Phaser.GameObjects.Image(scene, 60, -14, "texture_atlas_1", "lock");
            lock.scale = .7;
            this.add(lock);
        }

        const gameText = this.scene.cache.json.get("text");
        const key = CategoriesContainer.CATEGORIES_DATA[this.index - 1].key;

        const nameLabel = new Phaser.GameObjects.Text(scene, 0, -10, gameText[key][GameVars.gameData.data.language], {fontFamily: "OpenSans-CondLight", fontSize: "24px", color: "#644329"});
        nameLabel.setOrigin(.5);
        this.add(nameLabel);

        if (nameLabel.width > 96) {
            nameLabel.setScale(96 / nameLabel.width);
        }

        const progressionBarContainer = new Phaser.GameObjects.Image(scene, 0, 12, "texture_atlas_1", "progression-bar-background");
        this.add(progressionBarContainer);

        this.progressionBar = new Phaser.GameObjects.Image(scene, -68, 12, "texture_atlas_1", "progression-bar");
        this.progressionBar.setOrigin(0, .5);
        this.progressionBar.scaleX = progressionBarScale;
        this.add(this.progressionBar);

        const percentageLabel = new Phaser.GameObjects.Text(scene, 0, 12, numUnlocked + "/" + n, {fontFamily: "Arial", fontSize: "19px", color: "#FFFFFF"});
        percentageLabel.setOrigin(.5);
        this.add(percentageLabel);

        this.marker = new Phaser.GameObjects.Image(scene, CategoriesContainer.CATEGORIES_DATA[this.index - 1].markerPosition.x, CategoriesContainer.CATEGORIES_DATA[this.index - 1].markerPosition.y, "texture_atlas_1", "highlight_category");
        this.marker.alpha = 0;
        this.add(this.marker);

        const boundingBoxData = CategoriesContainer.CATEGORIES_DATA[this.index - 1].boundingBox;
        this.boundingBox = new Phaser.GameObjects.Rectangle(scene, boundingBoxData.x, boundingBoxData.y, boundingBoxData.w, boundingBoxData.h, 0xFFFF00, GameConstants.DEVELOPMENT ? .5 : 0);
        this.boundingBox.setOrigin(.5);
        this.boundingBox.setInteractive({useHandCursor: true});
        if (!this.locked) {
            this.scene.time.delayedCall(500, function(): void {
                this.boundingBox.on("pointerup", this.onCategoryUp, this);
                this.boundingBox.on("pointerover", this.onCategoryOver, this);
                this.boundingBox.on("pointerout", this.onCategoryOut, this);
            }, [], this);
        } 
        this.add(this.boundingBox);

        // MIRAR SI CUANTOS NIVELES SE HAN DESBLOQUEADO DE ESTA CATEGORIA
        // contar cuantas veces hay la categoria en el array de categorias jugadas
        // si es 0, esta bloqueada

        const count = GameVars.justUnlockedBoardsData.filter(item => item === this.type).length;

        if (count > 0) {
            const newLevelsLabelBackground = new Phaser.GameObjects.Graphics(this.scene);
            newLevelsLabelBackground.fillStyle(0xe41e37);
            newLevelsLabelBackground.x = 70;
            newLevelsLabelBackground.y = -20;
            newLevelsLabelBackground.fillCircle(0, 0, 14);
            this.add(newLevelsLabelBackground);
    
            const newLevelsLabel = new Phaser.GameObjects.Text(this.scene, newLevelsLabelBackground.x, newLevelsLabelBackground.y, count.toString(), {fontFamily: "OpenSans-CondLight", fontSize: 22, color: "#FFFFFF"});
            newLevelsLabel.setOrigin(.5);
            this.add(newLevelsLabel);
        }
     
        // HACER QUE SE LLAME AL METODO PREUPDATE DE ESTA CLASE
        this.scene.events.on("preupdate", this.preUpdate, this);
    }

    private preUpdate(): void {

        if (this.patch) {

            const n = CategoriesContainer.CATEGORIES_DATA[this.index - 1].orderAlphaTween * 10;

            if (CategoriesContainer.f === n && this.scene) {

                this.scene.tweens.add({
                    targets: this.patch,
                    alpha: 0,
                    duration: 750,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    yoyo: true
                });
            }
        }
    }

    private onCategoryUp(): void {

        if (SplashScene.currentInstance.categoryLayer !== null || SplashScene.currentInstance.firstSessionLayer !== null ||  SplashScene.currentInstance.brandingLayer !== null || SplashScene.currentInstance.transitioning || SplashScene.currentInstance.settingsLayer) {
            return;
        }

        SplashScene.currentInstance.showCategoryLayer(this.type);

        AudioManager.playSound("btn_press");
    }

    private onCategoryOver(): void {

        if (SplashScene.currentInstance.categoryLayer !== null || SplashScene.currentInstance.firstSessionLayer !== null ||  SplashScene.currentInstance.brandingLayer !== null || SplashScene.currentInstance.transitioning || SplashScene.currentInstance.settingsLayer) {
            return;
        }

        if (!this.locked) {

            this.marker.alpha = 0;

            this.marker.setScale(2 * CategoriesContainer.CATEGORIES_DATA[this.index - 1].markerPosition.scale);

            this.scene.tweens.add({
                targets: this.marker,
                alpha: 1,
                scaleX: CategoriesContainer.CATEGORIES_DATA[this.index - 1].markerPosition.scale,
                scaleY: CategoriesContainer.CATEGORIES_DATA[this.index - 1].markerPosition.scale,
                duration: 500,
                ease: Phaser.Math.Easing.Cubic.Out
            });
        }
    }

    private onCategoryOut(): void {

        if (SplashScene.currentInstance.categoryLayer !== null || SplashScene.currentInstance.firstSessionLayer !== null ||  SplashScene.currentInstance.brandingLayer !== null || SplashScene.currentInstance.transitioning || SplashScene.currentInstance.settingsLayer) {
            return;
        }

        if (!this.locked) {

            this.scene.tweens.add({
                targets: this.marker,
                alpha: 0,
                duration: 1000,
                ease: Phaser.Math.Easing.Linear
            });
        }
    }
}
